/*
* Created by Skeets 2017-12-13
* */
var ajaxWorker;

function wajax(obj)
{

  var sendObj = {};

  sendObj.url  = obj.url;
  sendObj.data = obj.data;
  sendObj.csrf = csrfToken;


  if (typeof(Worker) !== "undefined") {
    if (typeof(ajaxWorker) === "undefined") {
      ajaxWorker = new Worker(ajaxWebWorkerScript);
    }


    ajaxWorker.postMessage(JSON.stringify(sendObj));

    ajaxWorker.onmessage = function(event) {
      obj.success(event.data);
    };
  }
  else {
    // Here, just do a regular ajax call....
  }
}
